import React from "react";
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Legend, ResponsiveContainer, BarChart, Bar, Tooltip } from "recharts";
import { lines } from "../../Data/chartData";
import { useIsMobile } from "../../Hooks";
import useStyles from "./FmReleaseChart.style";

const renderLinesContent = () => {
    return lines.map((line, index) => (
        <Line
            key={index}
            type={line.type}
            dataKey={line.dataKey}
            stroke={line.color}
            strokeWidth={2}
            dot={{
                stroke: line.color,
                strokeWidth: 2,
                r: 3,
                fill: line.color,
            }}
        />
    ));
};

const renderBarsContent = () => {
    return lines.map((line, index) => <Bar key={index} dataKey={line.dataKey} fill={line.color} />);
};

interface FmReleaseChartProps {
    graphType: string;
    id?: any;
    graphData: any;
}

const FmReleaseChart = ({ graphType, id, graphData }: FmReleaseChartProps) => {
    const classes = useStyles();
    const isMobile = useIsMobile();

    console.log({ graphData });

    const graphTypeContent =
        graphType === "Line" ? (
            <LineChart width={800} height={350} data={graphData}>
                {renderLinesContent()}
                <CartesianGrid strokeDasharray='3 3' />
                <XAxis dataKey='name' />
                <YAxis />
                <Tooltip
                    formatter={function (value: any, tip: any, name: any) {
                        return `${value}, remain ${name.payload.tooltip[name.dataKey]}`;
                    }}
                />
                <Legend />
            </LineChart>
        ) : (
            <BarChart width={800} height={350} data={graphData}>
                {renderBarsContent()}
                <CartesianGrid strokeDasharray='3 3' />
                <XAxis dataKey='name' />
                <YAxis />
                <Tooltip />
                <Legend />
            </BarChart>
        );

    return (
        <div id={id} className={isMobile ? classes.mobile_container : classes.container}>
            <div className={isMobile ? classes.mobile_wrapper : classes.desktop_wrapper}>
                <ResponsiveContainer width={isMobile ? 1000 : "100%"} height='100%'>
                    {graphTypeContent}
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default FmReleaseChart;
